<template>
  <FlightDealsSection />
</template>

<script>
import FlightDealsSection from '../components/sections/FlightDealsSection.vue'

export default {
  name: 'FlightsPage',
  components: {
    FlightDealsSection
  }
}
</script>
